import { differenceInMonths, parseISO } from 'date-fns'

export interface DateRangeGuardConfig {
  maxMonthsBeforeWarning: number
}

export const DEFAULT_DATE_RANGE_GUARD: DateRangeGuardConfig = {
  maxMonthsBeforeWarning: 6,
}

export function isLargeDateRange(
  from: string | undefined,
  to: string | undefined,
  config: DateRangeGuardConfig = DEFAULT_DATE_RANGE_GUARD,
): boolean {
  if (!from || !to) return false
  try {
    const months = differenceInMonths(parseISO(to), parseISO(from))
    return months > config.maxMonthsBeforeWarning
  } catch {
    return false
  }
}

export function getMonthCount(
  from: string | undefined,
  to: string | undefined,
): number {
  if (!from || !to) return 0
  try {
    return differenceInMonths(parseISO(to), parseISO(from))
  } catch {
    return 0
  }
}
